// i18Moxly-extract-mark-ns-start main-page

import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import Hero from 'src/components/sections/hero'
import TeaserWithHighlight from 'src/components/sections/teaser/TeaserWithHighlight'
import CaseStudiesSection from 'src/components/sections/caseStudies/CaseStudiesSection'
import TrustedBy from 'src/components/sections/trusted-by'
import ContactSection from 'src/components/sections/ContactSection'
import AppPromoSection from 'src/components/sections/app-promo'
import ScrollingMarquee from 'src/components/ui/ScrollingMarquee'
import { getPageContent } from 'src/helpers/pageContent'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }

  const { t } = useTranslation('side-menu')

  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas} isHome={true}>
      <Hero
        translationContent={cmsJson.firstSection}
      />
      <TeaserWithHighlight
        translationContent={cmsJson.whoWeAreSection}
        showStatistics
        splitRatio='7/12'
        ctaVariant='link'
      />
      <ScrollingMarquee text="HOW WE WORK" />
      <div data-name={t('divisions')} id={t('divisions')}>
        <TeaserWithHighlight
          translationContent={cmsJson.imaginationSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
        <TeaserWithHighlight
          translationContent={cmsJson.designAndDevelopmentSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
        <TeaserWithHighlight
          translationContent={cmsJson.growthAndSupportSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
      </div>
      <TeaserWithHighlight
        translationContent={cmsJson.sportSection}
        splitRatio='7/12'
        imageMarginTop='md:pt-64'
        ctaVariant='link'
      />
      <AppPromoSection translationContent={cmsJson.rosaSection} />
      <TeaserWithHighlight
        translationContent={cmsJson.approachSection}
        splitRatio='7/12'
        imageMarginTop='md:pt-64'
      />
      <ScrollingMarquee text="PROJECTS" />
      <CaseStudiesSection
        items={data?.directus?.cases || []}
      />
      <TeaserWithHighlight
        translationContent={cmsJson.whyMamfSection}
        splitRatio='7/12'
        imageMarginTop='md:pt-64'
      />
      <TrustedBy translationContent={cmsJson.trustedBySection} />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
      cases: case_study(sort: "sort") {
        id
        slug
        platforms
        t: translations(
          filter: { languages_id: { code: { _eq: $language } } }
        ) {
          contentHeader: content_header
          excerpt
          subtitle
          firstPartOfTitle: title_part_1
          secondPartOfTitle: title_part_2
          ctaText: link_text
          languages_id {
            code
          }
        }
        desktopImage: desktop_image {
          id
        }
        detailsDesktopImage: details_desktop_image {
          id
        }
      }
    }
  }
`

export default IndexPage
